import { FaCoins } from 'react-icons/fa';

// "Win card" results screen, shown after a quiz round (on the dark stage).
// Uses the purple player-card illustration as the frame and overlays the
// real score in its three zones (top band / glass center / bottom band).
export default function SuccessScreen({
  coins,
  earned,
  correct,
  total,
  onContinue,
  onPlayAgain,
  ctaLabel,
}) {
  return (
    <div className="w-full max-w-sm flex flex-col items-center">
      {/* Win card */}
      <div className="relative w-full max-w-[340px] pop-in drop-shadow-2xl">
        <img
          src="/assets/app-illustration.svg"
          alt=""
          className="w-full block select-none pointer-events-none"
        />

        {/* Overlay aligned to the card's three zones */}
        <div className="absolute inset-0 flex flex-col items-center text-center px-[14%]">
          {/* Top band */}
          <div className="h-[20%] flex flex-col items-center justify-center">
            <span className="text-3xl">🏆</span>
            <h1 className="text-white font-black uppercase tracking-wide text-lg leading-none">
              Well Done!
            </h1>
          </div>

          {/* Glass center */}
          <div className="flex-1 flex flex-col items-center justify-center">
            <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest">
              Coins earned
            </span>
            <span className="flex items-center gap-1.5 text-5xl font-black text-amber-500 tabular-nums leading-none mt-1">
              <FaCoins className="text-3xl" />+{earned}
            </span>

            <div className="mt-5 w-full max-w-[150px] space-y-2 text-xs">
              <div className="flex items-center justify-between text-slate-600">
                <span className="font-bold">Correct</span>
                <span className="font-black text-slate-900">
                  {correct}/{total}
                </span>
              </div>
              <div className="flex items-center justify-between text-slate-600">
                <span className="font-bold">Balance</span>
                <span className="font-black text-slate-900 flex items-center gap-1">
                  <FaCoins className="text-amber-500 text-[11px]" />
                  {coins}
                </span>
              </div>
            </div>
          </div>

          {/* Bottom band */}
          <div className="h-[11%] flex items-center justify-center">
            <span className="text-white font-black uppercase tracking-[0.3em] text-xs">
              QuizzyLoot
            </span>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="w-full max-w-[340px] space-y-3 mt-6">
        {onPlayAgain && (
          <button
            onClick={onPlayAgain}
            className="btn-3d w-full py-4 bg-emerald-600 hover:bg-emerald-500 rounded-2xl text-white font-black uppercase tracking-widest text-sm"
          >
            Play Again
          </button>
        )}
        <button
          onClick={onContinue}
          className="btn-3d w-full py-4 bg-violet-600 hover:bg-violet-500 rounded-2xl text-white font-black uppercase tracking-widest text-sm flex items-center justify-center gap-3"
        >
          {ctaLabel || 'Continue'} <span className="text-xl">→</span>
        </button>
      </div>
    </div>
  );
}
